// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__38iah","Banner":"Box_Banner__2wTjA"};